import React from 'react';
import comingSoon from '../../images/upcoming.jpg'
const Blogs = () => {
    return (
        <div className='flex justify-center align-middle mb-36'>
            <img className='w-1/3 rounded-xl' src={comingSoon} alt="" />
        </div>
    );
};

export default Blogs;